import request from '#/utils/request';
import useSWRMutation from 'swr/mutation';

/**
 * useWatcherAddressUpdateMutation
 */
export default function useWatcherAddressUpdateMutation() {
  return useSWRMutation(
    '/api/v1/watcher/address/update',
    (
      url,
      {
        arg,
      }: {
        arg: {
          symbol: string;
          address: string;
          label?: string;
        };
      }
    ) => request.post(url, arg)
  );
}
